import A11yDialog from 'a11y-dialog';
import { throttle } from './helpers/throttle.js';
import { isTouch } from './helpers/is-touch.js';
import { setCookie, getCookie } from './helpers/cookies.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

// CTA Modals
( function() {
	let dialogs = document.querySelectorAll('.dialog');
	let len = dialogs.length;
	if (!len) return;

	// move dialogs below #page
	let body = document.body;
	let page = document.getElementById( 'page' );
	for ( let i = 0; i < len; i++ ) {
		body.insertBefore( dialogs[i], page );
	}
	body.insertBefore( page, dialogs[0] );

	// prevent scrolling while dialog is open
	for (let dialog of dialogs) {
		dialog.addEventListener('show', function () {
			console.log('dialog opened');
			// document.documentElement.style.overflowY = 'hidden';
			disableBodyScroll(dialog);
		});

		dialog.addEventListener('hide', function () {
			console.log('dialog closed');
			// document.documentElement.style.overflowY = '';
			enableBodyScroll(dialog);
		});
	}
} )();

( function() {
	let cta = document.querySelector('.cta-dialog');
	if (!cta) return;
	let id = cta.id;
	if (!id) return;
	let dialog = new A11yDialog(cta),
		trigger = cta.getAttribute('data-modal-trigger'),
		expiry = cta.getAttribute('data-modal-expiry'),
		cookie = id + '-shown',
		is_scroll = trigger === 'scroll',
		is_exit = trigger === 'exit',
		is_time = trigger.includes('seconds'),
		body = document.body,
		scrollTimer;

	console.log(trigger);
	console.log(is_scroll);
	trigger = isTouch() ? 'scroll' : trigger;

	if (cta.closest('.single-imthink-modal')) {
		window.addEventListener('load', function() {
			dialog.show();
		});
		return;
	}

	if (getCookie(cookie) || sessionStorage.getItem(cookie)) return;

	function showOnScroll() {
		if (document.body.scrollTop > 900 || document.documentElement.scrollTop > 900) {
			dialog.show();
		}
	}

	function throttleShowOnScroll() {
		throttle(showOnScroll, scrollTimer, 250);
	}

	function showOnExit(event) {
		if (event.clientY < 0) {
			dialog.show();
		}
	}

	function showOnTime (seconds) {
		let ms = seconds * 1000;
		setTimeout(function() {
			dialog.show();
		}, ms);
	}

	dialog.on('hide', function () {
		if (is_scroll) window.removeEventListener('scroll', throttleShowOnScroll);
		if (is_exit) body.removeEventListener('mouseleave', showOnExit);
		if (expiry.includes('-days')) {
			let days = parseInt(expiry.replace('-days', ''));
			setCookie(cookie, true, days);
			return;
		}
		if (expiry === 'session') sessionStorage.setItem(cookie, 'true');
	})

	if (is_scroll) {
		window.addEventListener('scroll', throttleShowOnScroll);
		return;
	}
	console.log('why');

	if (is_time) {
		let seconds = parseInt(trigger.replace('-seconds', ''));
		showOnTime(seconds);
		return;
	}

	if (is_exit) {
		body.addEventListener('mouseleave', showOnExit);
		return;
	}
} )();




